import { Component, OnInit, Input, HostListener, ElementRef, ViewChild } from '@angular/core';
import { SlideshowComponent } from '@ibe.components/common/slideshow/slideshow.component';
import { ModalService } from '@ibe/services/ui';

export class Photo {
	src: string;
	label: string;
}

@Component({
	selector: 'app-simple-gallery',
	templateUrl: './simple-gallery.indra.component.html',
	styleUrls: ['./simple-gallery.component.scss']
})
export class INDRASimpleGalleryComponent implements OnInit {

	@ViewChild('galleryList') galleryList: ElementRef<any>;
	
	@Input() photos: Array<Photo> = [];

	activeIndex = 0;
	seatCharacteristics: any;
	activePhotoLabel: string;
	isStillLoading: boolean = true;

	constructor(
		private modalService: ModalService
	) { }

	ngOnInit() {
		if (this.photos) {
			this.activePhotoLabel = this.photos[0].label;
		}

		setTimeout(() => this.isStillLoading = false, 1500);

	}

	hasActivePhoto(): boolean {
		return this.photos && this.photos.length > 0 && typeof this.photos[this.activeIndex] !== 'undefined';
	}

	activePhoto(): Photo {
		return this.hasActivePhoto() ? this.photos[this.activeIndex] : null;
	}

	selectIndex(index) {
		this.activeIndex = index;
		this.INDRA_updateActivePhotoLabel();
	}
	
	INDRA_updateActivePhotoLabel() {
		this.activePhotoLabel = this.photos[this.activeIndex].label;
	}

	prev() {
		if (this.activeIndex == 0) {
			this.activeIndex = this.photos.length - 1;
		} else {
			--this.activeIndex;
		}
		this.INDRA_updateActivePhotoLabel();
		this.INDRA_galleryScroll();
	}

	next() {
		if ((this.activeIndex + 1) > (this.photos.length - 1)) {
			this.activeIndex = 0;
		} else {
			++this.activeIndex;
		}
		this.INDRA_updateActivePhotoLabel();
		this.INDRA_galleryScroll();
	}

	/**
	 * Horizontal scroll to thumbnail active of gallery
	*/
	INDRA_galleryScroll() {
		const gallery: HTMLBaseElement = this.galleryList.nativeElement;
		const galleryListLeftPosition = this.galleryList.nativeElement.children[0].offsetWidth * this.activeIndex;
		setTimeout(() => {
			gallery.scrollTo({ left: galleryListLeftPosition, top: 0, behavior: 'smooth' });
		}, 50);

	}
	
	INDRA_openSlideshow(type: string) {
		this.modalService.assignComponent(
			SlideshowComponent,
			this.photos,
			this.activeIndex
		);
		this.modalService.open();
	}

	/**
	 * Keyboard listener
	 * Navigate on autocomlete using keyboard
	 */
	@HostListener('window:keyup', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		event.stopPropagation();
		switch (event.key) {
			case 'ArrowLeft':
				this.prev();
				break;
			case 'ArrowRight':
				this.next();
				break;
			default:
				return;
		}
	}


	errorCallback(index) {
		this.photos.splice(index, 1);
	}

	loadCallback(event, photo) {
		photo.size = {
			width: event.target.naturalWidth,
			height: event.target.naturalHeight,
		};
		photo.landscape = event.target.naturalWidth > event.target.naturalHeight;
	}
}
